angular.module('hjApp').component('appComponent', {
    controller: 'AppCtrl',
    template: require('./app.component.html')
});
